import { render, staticRenderFns } from "./StaffPickLabel.vue?vue&type=template&id=99fab638&"
import script from "./StaffPickLabel.vue?vue&type=script&lang=js&"
export * from "./StaffPickLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports